import apiClient from './apiClient';

// Outward Documentation APIs
export const getOutwardDocumentationEntries = async (warehouse = null) => {
  const params = new URLSearchParams();
  if (warehouse) params.append('warehouse', warehouse);
  const qs = params.toString();
  const response = await apiClient.get(`/outward-documentation/entries${qs ? `?${qs}` : ''}`);
  return response.data;
};

export const extractOutwardDocumentation = async (entryId) => {
  const response = await apiClient.post(`/outward-documentation/extract/${entryId}`);
  return response.data;
};

export const updateOutwardDocumentation = async (entryId, data) => {
  const response = await apiClient.put(`/outward-documentation/update/${entryId}`, data);
  return response.data;
};

export const confirmOutwardDocumentation = async (entryId) => {
  const response = await apiClient.post(`/outward-documentation/confirm/${entryId}`);
  return response.data;
};

export const getJobWorkers = async () => {
  const response = await apiClient.get('/outward-documentation/job-workers');
  return response.data;
};
